var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5664 15.7832C30.5664 7.5332 23.8164 0.783203 15.5664 0.783203C7.31641 0.783203 0.566406 7.5332 0.566406 15.7832C0.566406 23.2832 6.00391 29.4707 13.1289 30.5957V20.0957H9.37891V15.7832H13.1289V12.4082C13.1289 8.6582 15.3789 6.5957 18.7539 6.5957C20.4414 6.5957 22.1289 6.9707 22.1289 6.9707V10.7207H20.2539C18.3789 10.7207 17.8164 11.8457 17.8164 12.9707V15.7832H21.9414L21.1914 20.0957H17.6289V30.7832C25.1289 29.6582 30.5664 23.2832 30.5664 15.7832Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.1f94621b.svg";
export { ForwardRef as ReactComponent };